import '../css/app.css';
// Note: consent.css is loaded separately via @vite in app.blade.php for better caching
import './bootstrap';

import React from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import * as Klaro from 'klaro/dist/klaro-no-css';
import { klaroConfig, initializePostHog, initializeClarity } from '@/config/klaro';
import { ToastProvider } from '@/contexts/ToastContext';

const appName = import.meta.env.VITE_APP_NAME || 'WASHI';

// Initialize analytics immediately in cookieless/pending mode.
// PostHog runs with `cookieless_mode: 'on_reject'` - basic anonymous analytics until consent.
// Klaro callbacks then signal consent decisions via opt_in_capturing() / opt_out_capturing().
initializePostHog();
initializeClarity();

// Render Klaro consent banner (callbacks signal consent decisions to already-initialized services)
Klaro.render(klaroConfig);

createInertiaApp({
  title: title => `${title} - ${appName}`,
  resolve: name =>
    resolvePageComponent(
      `./pages/${name}.tsx`,
      import.meta.glob(['./pages/**/*.tsx', '!./pages/**/*.test.tsx', '!./pages/**/*.spec.tsx']),
    ),
  setup({ el, App, props }) {
    const root = createRoot(el);

    root.render(
      <React.StrictMode>
        <PostHogProvider client={posthog}>
          <ToastProvider>
            <App {...props} />
          </ToastProvider>
        </PostHogProvider>
      </React.StrictMode>,
    );
  },
  progress: {
    color: '#4B5563',
  },
});
